import { PageWrapper } from "@/components";
import { SearchInput, SearchPanel } from "@/components/Search/styled";
import * as GlobalS from "@/components/styled";
import { CONTENT_WIDTH, GUTTER_SIZE } from "@/enums";
import { routes } from "@/helpers";
import { useGetConditionalAccessGroupsQuery } from "@/services";
import { Pager } from "@/sharedStyled";
import { faEdit } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Checkbox, Col, Row, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
} from "use-query-params";

const DEFAULT_PAGE = 1;
const PAGE_SIZE = 10;

export const ListConditionalAccessGroups = () => {
  const intl = useIntl();

  const [queryParams, setQueryParams] = useQueryParams({
    page: NumberParam,
    top: NumberParam,
    name: StringParam,
    filterHasRules: BooleanParam,
  });

  const {
    data: { data: conditionalAccessGroups, totalCount } = {},
    isFetching,
    isError,
  } = useGetConditionalAccessGroupsQuery(queryParams);

  useEffect(() => {
    if (!isError) return;

    toast.error(intl.formatMessage({ id: "general.toastSomethingWentWrong" }));
  }, [intl, isError]);

  const columns = [
    {
      title: intl.formatMessage({
        id: "conditionalAccess.name",
      }),
      dataIndex: "name",
    },
    {
      title: intl.formatMessage({
        id: "general.actions",
      }),
      dataIndex: "id",
      render: (id) => (
        <Link to={routes.admin.conditionalAccess.get(id)}>
          <Button
            type="link"
            data-test-id={`conditional-access-${id}-edit`}
            icon={<FontAwesomeIcon icon={faEdit} />}
          />
        </Link>
      ),
    },
  ];

  const [searchInput, setSearchInput] = useState(queryParams.name);
  const [onlyWithRules, setOnlyWithRules] = useState(
    queryParams.filterHasRules
  );
  useEffect(() => {
    setSearchInput(queryParams.name);
    setOnlyWithRules(queryParams.filterHasRules);
  }, [queryParams.name, queryParams.filterHasRules]);

  return (
    <>
      <PageWrapper
        pageTitle={intl.formatMessage({ id: "conditionalAccess.title" })}
      >
        <Row className="pb-2" align="middle">
          <Col xs={22} sm={20} md={16} lg={12} xl={8}>
            <SearchPanel>
              <Tooltip
                placement={"bottom"}
                title={intl.formatMessage({
                  id: "conditionalAccess.searchTooltip",
                })}
              >
                <SearchInput
                  data-test-id={"conditional-access-search-input"}
                  onSearch={(searchValue) =>
                    setQueryParams({
                      ...queryParams,
                      name: searchValue,
                      page: DEFAULT_PAGE,
                    })
                  }
                  onChange={(onChangeEvent) =>
                    setSearchInput(onChangeEvent.target.value)
                  }
                  value={searchInput}
                  loading={isFetching}
                />
              </Tooltip>
            </SearchPanel>
          </Col>
          <Col xs={5} sm={5} md={4} lg={3} xl={2}>
            <SearchPanel>
              <Tooltip
                placement={"bottom"}
                title={intl.formatMessage({
                  id: "conditionalAccess.onlyAssignedTooltip",
                })}
              >
                <Checkbox
                  data-test-id={"conditional-access-search-only-rules-checkbox"}
                  checked={onlyWithRules}
                  onChange={({ target: { checked } }) => {
                    setOnlyWithRules(checked);
                    setQueryParams({
                      filterHasRules: checked,
                    });
                  }}
                >
                  {intl.formatMessage({
                    id: "conditionalAccess.onlyAssigned",
                  })}
                </Checkbox>
              </Tooltip>
            </SearchPanel>
          </Col>
        </Row>
        <Row gutter={GUTTER_SIZE.small}>
          <Col span={CONTENT_WIDTH.max}>
            <GlobalS.PageContentCard
              title={intl.formatMessage({
                id: "conditionalAccess.listCartTitle",
              })}
            >
              <Table
                columns={columns}
                dataSource={conditionalAccessGroups}
                rowKey={"id"}
                pagination={false}
                loading={isFetching}
              />
              <Pager
                defaultCurrent={queryParams.page || DEFAULT_PAGE}
                current={queryParams.page || DEFAULT_PAGE}
                pageSize={queryParams.top || PAGE_SIZE}
                total={totalCount}
                showSizeChanger={false}
                onChange={(page) => setQueryParams({ page: page })}
                data-test-id="conditional-access-table-pagination"
              />
            </GlobalS.PageContentCard>
          </Col>
        </Row>
      </PageWrapper>
    </>
  );
};
